/**
 * One string in as many grammatical forms as a language needs for a count.
 * Which form applies is decided by `Intl.PluralRules`, never by hand: "1
 * hour / 2 hours" is two forms in English and three in Polish (1 godzina /
 * 2 godziny / 5 godzin), and a hand-rolled `n === 1 ? a : b` gets Polish
 * wrong on its second value.
 *
 * `other` is required because every language has it; the rest are filled in
 * only where that language uses them. `{count}` in any form is replaced
 * with the number.
 */
export type PluralForms = Partial<Record<Intl.LDMLPluralRule, string>> & { other: string };

/**
 * Identity helper whose only job is to pin a plural entry's type to
 * `PluralForms`. Without it, `typeof en` would infer the exact set of forms
 * English happens to use and reject the extra `few`/`many` that Polish
 * needs. Write plural entries as `plural({ one: "…", other: "…" })`.
 */
export const plural = (forms: PluralForms): PluralForms => forms;
